import { AsyncService } from '../services/async-service';
import { Directive } from '../classes';

export class AsyncChunkComponent extends Directive {
    public static get $name() {
        return 'asyncChunk';
    }

    public static get $priority() {
        return 100000;
    }

    public static get $terminal() {
        return true;
    }

    public static get $inject() {
        return ['$compile', '$injector'];
    }

    constructor(private $compile: any) {
        super();
    }

    public compile($element: JQuery, $attrs: angular.IAttributes) {
        const chunkName: string = $attrs['asyncChunk'];
        if (!chunkName) {
            console.error('asyncChunk.error: no chunk name defined!');
        }

        $element.removeAttr('async-chunk');

        return ($scope: angular.IScope, $element: JQuery): void => {
            if (!AsyncService.loaded(chunkName)) {
                AsyncService.run(chunkName).then(() => {
                    $scope.$applyAsync(() => {
                        this.$compile($element)($scope);
                    });
                });
            } else {
                $scope.$applyAsync(() => {
                    this.$compile($element)($scope);
                });
            }
        };
    }
}
